import { render, staticRenderFns } from "./MigrationExplanation.vue?vue&type=template&id=35c0d400"
var script = {}
import style0 from "./MigrationExplanation.vue?vue&type=style&index=0&id=35c0d400&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports